<template>
  <Navigation :currentPage="'res'" />
  <div class="resources">
    <Menu/>
    <ResList/>
    <KuFooter/>
  </div>
</template>

<script>
// @ is an alias to /src
import Navigation from '@/components/Navigation.vue'
import ResList from '@/components/ResList.vue';
import Menu from '@/components/Menu.vue';
import KuFooter from '@/components/KuFooter.vue';

export default {
  name: 'Resources',
  components: {
    Navigation,
    ResList,
    Menu,
    KuFooter,
  }
}
</script>

<style>

.resources{
  margin: 0;
  padding: 0;
}

</style>
